import { ProductSearchData, UseProductSearch } from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "productSearch";

const useProductSearch: UseProductSearch = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ProductSearchData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const { data } = value;
  const variant = data?.enabled ? "test" : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useProductSearch;
